import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import StabilityApp from "./StabilityApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StabilityApp />
  </React.StrictMode>,
);
